import {Dispatch, FC} from 'react';
import {
  OperatoryListProps,
  TreatmentResponseProps
} from '../../constants/types';
import {AreBlocksExpandedProps, AvailableFiltersProps} from './types';
import {Checkbox, FormControlLabel, FormGroup} from '@mui/material';

interface ExpandableTextFilterBlockProps {
  data:
    OperatoryListProps[] |
    TreatmentResponseProps[] |
    {id: number, value: string}[] |
    null;
  filterItem: {
    title: string,
    idKey: string,
    valueKey: string,
    filterType: string
  };
  allFilters: AvailableFiltersProps,
  setAllFilters: Dispatch<AvailableFiltersProps>,
  areBlocksExpanded: AreBlocksExpandedProps,
  setAreBlocksExpanded: Dispatch<AreBlocksExpandedProps>
}

const ExpandableTextFilterBlock: FC<ExpandableTextFilterBlockProps> = ({
  data,
  filterItem,
  allFilters,
  setAllFilters,
  areBlocksExpanded,
  setAreBlocksExpanded

}) => {
  const {title, idKey, valueKey, filterType} = filterItem;

  const handleSelectAllCheckboxChange = (target, data) => {
    if (!data) return;
    const isChecked = target.checked;

    if (isChecked) {
      const filterValues = data.map((item) => item[idKey]);
      setAllFilters({...allFilters, [filterType]: filterValues});
    } else {
      setAllFilters({...allFilters, [filterType]: []});
    }
  };

  const handleCheckboxChange = (target, id) => {
    const isChecked = target.checked;

    if (isChecked) {
      const filterValues =
        [...allFilters[filterType], Number(id)];
      setAllFilters({...allFilters, [filterType]: filterValues});
    } else {
      const filterValues =
        allFilters[filterType].filter((value) =>
          value !== Number(id));
      setAllFilters({...allFilters, [filterType]: filterValues});
    }
  };

  const renderSelectAllRows = () => {
    if (!data) return;

    return (
      <li className="filters-list-row">
        <FormGroup>
          <FormControlLabel
            control={(
              <Checkbox
                size="small"
                id={`select_all_for_${filterType}`}
                className="cursor-pointer"
                onChange={({target}) =>
                  handleSelectAllCheckboxChange(target, data)}
                checked={data.length === allFilters[filterType]?.length}
              />
            )}
            label="Select All"
          />
        </FormGroup>
      </li>
    );
  };

  const renderFilterRows = (rowItem, data) => {
    if (!data) return;

    const filterRows = data.map((item) => (
      <li
        key={`filter_row_${item[idKey]}_${item[valueKey]}`}
        className="filters-list-row"
      >
        <FormGroup>
          <FormControlLabel
            control={(
              <Checkbox
                size="small"
                id={`checkbox_for_${filterType}_${item[idKey]}`}
                className="cursor-pointer"
                onChange={({target}) =>
                  handleCheckboxChange(target, item[idKey])}
                checked={allFilters[filterType].includes(item[idKey])}
              />
            )}
            label={item[valueKey]}
          />
        </FormGroup>
      </li>
    ));

    return (
      <>
        {renderSelectAllRows()}
        {filterRows}
      </>
    );
  };

  return (
    <div className="expandable-block">
      <ul className="filters-list">
        <li
          className="filters-list-row cursor-pointer space-between"
          onClick={() => setAreBlocksExpanded({
            ...areBlocksExpanded,
            [filterType]: !areBlocksExpanded[filterType]
          })}>
          <span className="bold-text">
            {title}
          </span>
          <span className="bold-text">
            {areBlocksExpanded[filterType] ? '-' : '+'}
          </span>
        </li>
        {areBlocksExpanded[filterType] &&
          renderFilterRows(filterItem, data)}
      </ul>
    </div>
  );
};

export default ExpandableTextFilterBlock;
